import { Field } from "react-final-form";
import TextFieldAdapter from "@soqs/common/dist/Components/Adapters/TextFieldAdapter";

export interface PhoneFieldProps {
  name: string;
  required: boolean;
  label: string;
  id?: string;
}

const PhoneFieldComponent = (props: PhoneFieldProps) => {
  const isValid = (tel: string) => {
    const re = /^[0-9]{10,15}$/;
    const telLength = tel === null || tel === void 0 ? void 0 : tel.length;
    return (tel || !props.required) && (re.test(tel) || (!props.required && (tel === undefined || telLength === 0))) ? undefined : "Enter a valid " + props.label;
  };

  const stripSpaces = (value: string) => {
    return value ? value?.trim() : "";
  };

  return (
    <Field
      name={props.name}
      validate={isValid}
      label={props.label}
      autoComplete={"tel-national"}
      required={props.required}
      component={TextFieldAdapter}
      subscription={{
        touched: true,
        value: true,
        error: true
      }}
      parse={stripSpaces}
      fullWidth={true}
      inputProps={{
        maxLength: 15
      }}
      id={props.id ?? props.name}
    />
  );
};

export default PhoneFieldComponent;